<script setup lang="ts">
import DimensionInput from "@/components/UI/DimensionInput.vue";
import { addSizeToDataLayer } from "@/functions/analytics";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'quarter-circle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const radius = computed({
	get: () => dimensions.value.radius,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "radius",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="quarter-circle-radius"
			:id="`${prefix}measurements-quarter-circle-radius`"
			:name="`${prefix}measurements[dimensions][radius]`"
			unit="cm"
			:label="dimensionLabel('radius', 'quarter-circle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('radius')"
			:invalid="!isDimensionValid(`${prefix}quarter-circle-radius`)"
			:onBlur="() => addSizeToDataLayer('radius', +radius, 'quarter-circle')"
			v-model="radius"
		/>
	</shape-input-fields-wrapper>
</template>
